/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
import { useEffect, useState, useRef } from 'react';
import { Tabs, Tab, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import arrowUp from '../../../assets/images/svg/arrow-up-white.svg';
import { SimpleButton } from '../../button';
import { HeadingDesc, HeadingDescSmall } from '../../Headings';
import SlideSearchIcon from '../../slideSearchIcon/SlideSearchIcon';
import img1 from '../../../assets/images/svg/specaility1.svg';
import img2 from '../../../assets/images/svg/specaility2.svg';
import img3 from '../../../assets/images/svg/specaility3.svg';
import searchIcon from '../../../assets/images/svg/search-black.svg';
import './findDoctorByDiseaseFilter.css';

const specialities = [
  { image: img1, title: 'Acupuncture', docAvailable: '9' },
  { image: img2, title: 'Allergy Specialist', docAvailable: '21' },
  { image: img3, title: 'Andrologist', docAvailable: '15' },
  { image: img2, title: 'Anesthetist', docAvailable: '45' },
  { image: img1, title: 'Audiologist', docAvailable: '38' },
  { image: '', title: 'Bariatric/Weight Loss', docAvailable: '15' },
  { image: '', title: 'Cancer Specialist', docAvailable: '45' },
  { image: '', title: 'Cardiac Surgeon', docAvailable: '38' },
  { image: '', title: 'Cardiologist', docAvailable: '30' },
  { image: '', title: 'Cardiothoracic Anesthetist', docAvailable: '20' },
  { image: '', title: 'Chest Surgeon', docAvailable: '61' }
];

function FindDoctorByDiseaseFilter() {
  const [alphabates] = useState([
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
  ]);
  const [keyForTabs, setKeyForTabs] = useState('');

  const [dictionary, setDictionary] = useState(new Map());

  // sort all diseases based on first letter
  // link diseases with letters
  useEffect(() => {
    const sortedDiseases = specialities.sort((a, b) => {
      return a.title > b.title ? 1 : -1;
    });

    let i = 0;
    alphabates.map((alphabet) => {
      if (!dictionary.has(alphabet)) {
        dictionary.set(alphabet, []);
      }

      for (; i < sortedDiseases.length; i += 1) {
        const speciality = sortedDiseases[i].title;
        if (speciality?.toLowerCase().indexOf(alphabet) === 0) {
          dictionary.get(alphabet).push(sortedDiseases[i]);
        } else {
          return;
        }
      }

      if (dictionary.get(alphabet).length === 0) {
        dictionary.delete(alphabet);
      }
    });

    setDictionary(dictionary);
    setKeyForTabs('speciality');
  }, []);

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

  const ForTop = useRef(null);
  const ForLetter = useRef(null);
  const executeScrollForTop = () => scrollToRef(ForTop);
  const executeScrollForLetter = () => scrollToRef(ForLetter);

  return (
    <section className="findDoctorByDiseaseFilter" ref={ForTop}>
      <Container>
        <div className="tabContainer">
          <SlideSearchIcon icon={searchIcon} />
          <Tabs
            id="controlled-tab-speciality"
            activeKey={keyForTabs}
            transition
            onSelect={(k) => setKeyForTabs(k)}
            className="mb-3 customTabs"
          >
            <Tab eventKey="speciality" title="By Speciality">
              <div className="filter_btns">
                {alphabates.map((alphabate, index) => (
                  <button
                    type="button"
                    className="filter_btn"
                    onClick={executeScrollForLetter}
                    key={index}
                  >
                    {alphabate}
                  </button>
                ))}
              </div>
              <Row>
                <Col md={8}>
                  {alphabates.map((letter, index) => {
                    return dictionary.get(letter)?.length > 0 ? (
                      <div
                        className="filterContent"
                        ref={ForLetter}
                        key={index}
                      >
                        <h2 className="filterLetter">
                          {letter.toUpperCase() || ''}
                        </h2>
                        <ul className="filterList">
                          {dictionary.get(letter)?.map((item) => {
                            const { image, title, docAvailable } = item;
                            return (
                              <li key={title}>
                                <Link to="/">
                                  <div className="listBox">
                                    {image && (
                                      <div className="imgBox">
                                        <img src={image} alt="icon" />
                                      </div>
                                    )}
                                    <div>
                                      <HeadingDesc text={title} />
                                      <HeadingDescSmall
                                        text={`${docAvailable} Doctors Available`}
                                      />
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ) : (
                      ''
                    );
                  })}
                  <SimpleButton onClick={executeScrollForTop}>
                    <img src={arrowUp} alt="arrowUp" className="arrowUpWhite" />
                    back to top
                  </SimpleButton>
                </Col>
                <Col md={4}>
                  <div className="add">
                    <h2> Ad Space </h2>
                  </div>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="condition" title="By Condition" />
            <Tab eventKey="treatment" title="By Treatment" />
            <Tab eventKey="city" title="By City" />
          </Tabs>
        </div>
      </Container>
    </section>
  );
}

export default FindDoctorByDiseaseFilter;
